import { Injectable } from '@angular/core';
import { BehaviorSubject, concat, forkJoin, Observable, of, throwError, Subject } from 'rxjs';
import { map, catchError, tap, debounceTime } from 'rxjs/operators';
import { Order } from '../models/order.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  // BehaviorSubjects for state management
  private _order = new BehaviorSubject<any>(null);
  private _arkiveorder = new BehaviorSubject<any>(null);
  private _orderss = new BehaviorSubject<any>(null);
  private _arkiveorderss = new BehaviorSubject<any>(null);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private _orderCount = new BehaviorSubject<any>(null);
  private _arkiveorderCount = new BehaviorSubject<any>(null);
  private countLoadingSubject = new BehaviorSubject<boolean>(false);
  
  private refreshOrderCountSubject = new Subject<any>();
  private lastOrderCountCall: { params: string, time: number } | null = null;
private _orderList$ = new Subject<any>();
orderList$ = this._orderList$.asObservable();
  // Observables
  order$ = this._order.asObservable();
  arkiveOrder$ = this._arkiveorder.asObservable();
  orderss$ = this._orderss.asObservable();
  loading$ = this.loadingSubject.asObservable();
  orderCount$ = this._orderCount.asObservable();
  arkiveOrderCount$ = this._arkiveorderCount.asObservable();
  countLoading$ = this.countLoadingSubject.asObservable();

  // Order data cache
  orderData: any = {
    order: null
  };
  arkiveOrderData: any = {
    arkiveOrder: null
  };

  orderCountData: any = {
    orderCount: null
  };
  arkiveOrderCountData: any = {
    orderCount: null
  };
  private activeDriversCache: any = null; // 🔥 Cache for driver listing


  get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthServiceService
  ) {
    // 🔹 Centralized Smart Refresh for Order Counts
    this.refreshOrderCountSubject.pipe(
      debounceTime(400)
    ).subscribe(params => {
      this.executeOrderCountFetch(params);
    });
  }

  /**
   * Fetch order list with filters and pagination
   * Clears old data before fetching new data to trigger loader
   */
 private latestRequestId = 0; // 🔥 Track latest request

orderList(
  search_text?: any,
  order_date?: any,
  order_status?: any,
  order_type?: any,
  driver_id?: any,
  page?: any
) {
  const requestId = ++this.latestRequestId; // 🔥 unique request id

  this.loadingSubject.next(true);

  let params = new URLSearchParams();

  if (search_text !== null && search_text !== undefined && search_text.trim().length > 0 && search_text !== "null") {
    params.set('search_text', search_text.trim());
  }

  if (order_date && order_date !== null && order_date !== "null" && order_date.length > 0) {
    params.set('order_date', order_date);
  }

  if (order_type && order_type !== null && order_type !== "null" && order_type.length > 0 && order_type !== 'both') {
    params.set('order_type', order_type);
  }

  if (order_status !== null && order_status !== undefined && order_status !== "undefined" && order_status !== 'null' && order_status.length > 0 && order_status[0] !== 'all') {
    params.set('order_status', order_status);
  }

  if (page !== null && page !== undefined) {
    params.set('page', (page + 1).toString());
  }

  if (driver_id && driver_id.toString().trim() !== '') {
    params.set('driver_id', driver_id);
  }

  let tail = params.toString() ? `?${params.toString()}` : '';

  this.http
    .get<any>(`${this._liveApiUrl}/company/order-listing/${tail}`)
    .pipe(
      map((data) => data),
      catchError((error) => {
        this.loadingSubject.next(false);
        return this.authService.handleError(error);
      })
    )
    .subscribe(
      (data: any) => {

        // 🔥 🔥 MAIN FIX — OLD RESPONSE IGNORE
        if (requestId !== this.latestRequestId) {
          console.log('❌ Old API response ignored');
          return;
        }

        console.log('✅ Latest API response accepted');

        // ❗ invalid page handle
        if (data.errorMessage === "Invalid page number") {
          if (page <= 0) {
            this.loadingSubject.next(false);
            return;
          }

          const previousPage = page - 1;
          this.orderList(search_text, order_date, order_status, order_type, driver_id, previousPage);
          return;
        }

        // ✅ Correct response
        this._order.next(data);
        this._orderss.next(data);
        this.orderData.order = data;

        this.loadingSubject.next(false);
      },
      (error) => {
        this.loadingSubject.next(false);
        this.authService.dataError(error);
      }
    );
}
  driverOrderListPending(search_text?: any, order_date?: any, order_status?: any, order_type?: any, driver_id?: any, page?: any) {
    // Clear old data first to show loader
    this._order.next(null);
    this._orderss.next(null);
    this.loadingSubject.next(true);

    let params = new URLSearchParams();

    if (search_text !== null && search_text !== undefined && search_text.trim().length > 0 && search_text !== "null") {
      params.set('search_text', search_text.trim());
    }

    if (order_date && order_date !== null && order_date !== "null" && order_date.length > 0) {
      params.set('order_date', order_date);
    }

    if (order_type && order_type !== null && order_type !== "null" && order_type.length > 0 && order_type !== 'both') {
      params.set('order_type', order_type);
    }

    if (order_status !== null && order_status !== undefined && order_status !== "undefined" && order_status !== 'null' && order_status.length > 0 && order_status[0] !== 'all') {
      params.set('order_status', order_status);
      if (order_status == 'pending') {
        params.set('driver_today_orders', 'true');
      }
    }

    if (page !== null && page !== undefined) {
      params.set('page', (page + 1).toString());
    }

    if (driver_id && driver_id.toString().trim() !== '') {
      params.set('driver_id', driver_id);
    }

    let tail = params.toString() ? `?${params.toString()}` : '';

    this.http
      .get<any>(`${this._liveApiUrl}/company/order-listing/${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((error) => {
          this.loadingSubject.next(false);
          return this.authService.handleError(error);
        })
      )
      .subscribe(
        (data: any) => {
          // Check for invalid page number FIRST - before other error checks
          if (data.errorMessage === "Invalid page number") {
            // Stop retry if we're already at page 0
            if (page <= 0) {
              this.loadingSubject.next(false);
              return;
            }
            const previousPage = page - 1;
            this.orderList(search_text, order_date, order_status, order_type, driver_id, previousPage);
            return;
          }

          // Then check for other errors

          // Success - update all data stores
          this._order.next(data);
          this._orderss.next(data);
          this.orderData.order = data;

          // Hide loader
          this.loadingSubject.next(false);
        },
        (error) => {
          this.loadingSubject.next(false);
          this.authService.dataError(error);
        }
      );
  }
  /**
   * Get loading state observable
   */
  getLoading(): Observable<boolean> {
    return this.loading$;
  }
driverOrderListPending1(
  search_text?: any,
  order_date?: any,
  order_status?: any,
  order_type?: any,
  driver_id?: any,
  page?: any
) {
  // Loader start
  this.loadingSubject.next(true);

  let params = new URLSearchParams();

  if (search_text?.trim() && search_text !== "null") {
    params.set('search_text', search_text.trim());
  }

  if (order_date && order_date !== "null") {
    params.set('order_date', order_date);
  }

  if (order_type && order_type !== "null" && order_type !== 'both') {
    params.set('order_type', order_type);
  }

  if (order_status && order_status !== 'null' && order_status[0] !== 'all') {
    params.set('order_status', order_status);

    if (order_status === 'pending') {
      params.set('driver_today_orders', 'true');
    }
  }

  if (page !== null && page !== undefined) {
    params.set('page', (page + 1).toString());
  }

  if (driver_id?.toString().trim()) {
    params.set('driver_id', driver_id);
  }

  let tail = params.toString() ? `?${params.toString()}` : '';

  this.http
    .get<any>(`${this._liveApiUrl}/company/order-listing/${tail}`)
    .pipe(
      catchError((error) => {
        this.loadingSubject.next(false);
        return this.authService.handleError(error);
      })
    )
    .subscribe(
      (data: any) => {

        if (data.errorMessage === "Invalid page number") {
          if (page <= 0) {
            this.loadingSubject.next(false);
            return;
          }
          this.driverOrderListPending(
            search_text,
            order_date,
            order_status,
            order_type,
            driver_id,
            page - 1
          );
          return;
        }

        // ✅ Subject me data emit
        this._orderList$.next(data);

        this.loadingSubject.next(false);
      },
      (error) => {
        this.loadingSubject.next(false);
        this.authService.dataError(error);
      }
    );
}
  /**
   * Set loading state manually
   */
  setLoading(isLoading: boolean): void {
    this.loadingSubject.next(isLoading);
  }

  /**
   * Get order data observable
   */
  getOrderData(): Observable<any> {
    return this.order$;
  }
  getOrderData1(): Observable<any> {
  return this.orderList$;
}
  getAriveOrderData(): Observable<any> {
    return this.arkiveOrder$;
  }
  getOrderDatas(compName: any, addrId: any) {
    // {{dev_comp_url}}/company/company-addres-filter/?company_name=new compnay&address_id=1
    compName = encodeURIComponent(compName);
    addrId = encodeURIComponent(addrId);
    return this.http.get(`${this._liveApiUrl}/company/company-addres-filter/?company_name=${compName}&address_id=${addrId}`)
  }
  /**
   * Get order data snapshot
   */
  getOrderDataSnapshot(): any {
    return this.orderData.order;
  }

  /**
   * Clear all order data
   */
  clearOrderData(): void {
    this._order.next(null);
    this._orderss.next(null);
    this.orderData.order = null;
  }


  orderCount(order_date?: any, order_type?: any, driver_id?: any, order_status?: any, today_date?: any, search_text?: any, ispending?: any) {
    // 🔹 Normalize parameters: convert undefined to null for consistent JSON.stringify
    const params = {
      order_date: order_date ?? null,
      order_type: order_type ?? null,
      driver_id: driver_id ?? null,
      order_status: order_status ?? null,
      today_date: today_date ?? null,
      search_text: search_text ?? null,
      ispending: ispending ?? null
    };

    // 🛡️ Extra Layer: Avoid identical calls within 1.5 seconds even if they pass debounce
    const paramsStr = JSON.stringify(params);
    const now = Date.now();
    if (this.lastOrderCountCall && this.lastOrderCountCall.params === paramsStr && (now - this.lastOrderCountCall.time < 1000)) {
      console.log('Skipping redundant order-count call');
      return;
    }
    
    this.lastOrderCountCall = { params: paramsStr, time: now };
    this.refreshOrderCountSubject.next(params);
  }

  private executeOrderCountFetch(p: any) {
    const { order_date, order_type, driver_id, order_status, today_date, search_text, ispending } = p;
    // Set loading state
    this.countLoadingSubject.next(true);

    let params = new URLSearchParams();

    if (order_date && order_date !== "null" && order_date.length > 0) {
      params.set('order_date', order_date);
    }

    if (order_type && order_type !== "null" && order_type.length > 0 && order_type !== 'both') {
      params.set('order_type', order_type);
    }

    if (driver_id && driver_id !== "null" && driver_id !== '') {
      params.set('driver_id', driver_id);
    }

    if (order_status && order_status !== "null" && order_status !== '') {
      params.set('order_status', order_status);
    }

    if (today_date && today_date !== "null" && today_date !== '') {
      params.set('today_date', today_date);
    }

    if (typeof search_text === 'string') {
      const trimmedSearch = search_text.trim();
      if (trimmedSearch && trimmedSearch !== "null") {
        params.set('search_text', trimmedSearch);
      }
    }

    if (ispending !== undefined && ispending !== null) {
      params.set('is_pending', ispending.toString());
    }

    let tail = params.toString() ? `?${params.toString()}` : '';

    this.http
      .get<any>(`${this._liveApiUrl}/company/order-counts/${tail}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          this.countLoadingSubject.next(false);
          return this.authService.handleError(error);
        })
      )
      .subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            this.countLoadingSubject.next(false);
            return;
          }

          // Update count data
          this.orderCountData.orderCount = data;
          this._orderCount.next(data);

          // Hide loader
          this.countLoadingSubject.next(false);
        },
        (error) => {
          this.countLoadingSubject.next(false);
          this.authService.dataError(error);
        }
      );
  }

  /**
   * Get order count observable
   */
  getOrderCount(): Observable<any> {
    return this.orderCount$;
  }
  getArkiveOrderCount(): Observable<any> {
    return this.arkiveOrderCount$;
  }

  /**
   * Get count loading state observable
   */
  getCountLoading(): Observable<boolean> {
    return this.countLoading$;
  }
  orderDelete(formdata: any): Observable<any> {
    return this.http.request<any>('DELETE', `${this._liveApiUrl}/company/delete-order/`, {
      body: formdata,
    }).pipe(
      map((data) => {
        // 🔹 Same check as orderCount
        if (this.authService.resultCodeError(data)) {
          return throwError(() => data);
        }
        return data;
      }),
      catchError((error) => {
        return this.authService.handleError(error);
      })
    );
  }

  orderunAssign(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/unassign-order/`, form)
      .pipe(
        map((data: any) => {
          // 🔹 Same check as orderCount
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

  orderRoute(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/route-orders/`, form)
      .pipe(
        map((data: any) => {
          // 🔹 Same check as orderCount
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

  getActiveDriversForReassign(status?: string, reassign: string = 'true'): Observable<any> {
    let params = new HttpParams()
      .set('page', 'all');

    if (reassign) {
      params = params.set('reassign', reassign);
    }

    if (status) {
      params = params.set('status', status);
    }

    return this.http.get<any>(
      `${this._liveApiUrl}/account/driver-listing/`,
      { params }
    ).pipe(
      map((data: any) => {
        // 🔹 Same pattern
        if (this.authService.resultCodeError(data)) {
          return throwError(() => data);
        }
        return data;
      }),
      catchError((error) => this.authService.handleError(error))
    );
  }

  getActiveDriversForReassignAll(reassign: string = 'all', date?: string): Observable<any> {
    let params = new HttpParams().set('reassign', reassign);
    if (date) {
      params = params.set('order_date', date);
    }
    return this.http.get<any>(
      `${this._liveApiUrl}/account/driver-listing/`,
      { params }
    ).pipe(
      map((data: any) => {
        if (this.authService.resultCodeError(data)) {
          return throwError(() => data);
        }
        return data;
      }),
      catchError((error) => this.authService.handleError(error))
    );
  }


  updateOrderDate(id: Number, form: any): Observable<any> {
    return this.http
      .put<any>(`${this._liveApiUrl}/company/order-date-update/${id}`, form)
      .pipe(
        map((data: any) => {
          // 🔹 Same pattern as other APIs
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

  orderPriority(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/order-priority/`, form)
      .pipe(
        map((data: any) => {
          // 🔹 Same pattern as your other APIs
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

  orderAssign(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/assign-order/`, form)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  getActiveDriversForAssign(status?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', 'all');

    if (status) {
      params = params.set('status', status);
    }

    return this.http.get<any>(
      `${this._liveApiUrl}/account/driver-listing/`,
      { params }
    ).pipe(
      map((data: any) => {
        // 🔹 Same pattern
        if (this.authService.resultCodeError(data)) {
          return throwError(() => data);
        }
        return data;
      }),
      catchError((error) => this.authService.handleError(error))
    );
  }
  orderDetail(id: number): Observable<any> {
    return this.http
      .get<any>(`${this._liveApiUrl}/company/order-details/${id}`)
      .pipe(
        map((data: any) => {
          // 🔹 Same pattern as other APIs
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  ordereschedule(id: number): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/reschedule-order/${id}/`, undefined)
      .pipe(
        map((data: any) => {
          // 🔹 Same pattern as other APIs
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  sendNotificationToDriverCustomer(formData: any): Observable<any> {
    return this.http
      .post<any>(`${this.authService._liveApiUrl}/notification/send-order-notification/`, formData)
      .pipe(
        map((data: any) => {
          // 🔹 Check for API error like in ordereschedule
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  orderDetailRNC(id: any, activeTab: 'customer' | 'driver', page: number = 1): Observable<any> {
    const order_id = Number(id.replace(/\D/g, ''));
    console.log('Order ID:', order_id, 'Active Tab:', activeTab);

    // Choose endpoint based on activeTab
    const endpoint =
      activeTab === 'customer'
        ? 'get-customer-notification'
        : 'get-driver-notification';

    return this.http
      .get<any>(
        `${this._liveApiUrl}/notification/${endpoint}/?order_id=${order_id}&page=${page}&type=Custom Order Notification`
      )
      .pipe(
        map((data: any) => {
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  orderDetailAllRNC(id: any, activeTab: 'customer' | 'driver', page: number = 1): Observable<any> {
    const order_id = Number(id.replace(/\D/g, ''));
    console.log('Order ID:', order_id, 'Active Tab:', activeTab);

    // Choose endpoint based on activeTab
    const endpoint =
      activeTab === 'customer'
        ? 'get-customer-notification'
        : 'get-driver-notification';

    return this.http
      .get<any>(
        `${this._liveApiUrl}/notification/${endpoint}/?order_id=${order_id}&all=true&type=Custom Order Notification`
      )
      .pipe(
        map((data: any) => {
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  uploadInvoice(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/upload-invoice/`, form)
      .pipe(
        map((data: any) => {
          // 🔹 Check for API error
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  getActiveDrivers(): Observable<any> {
    const params = new HttpParams()
      .set('status', 'active')
      .set('page', 'all');

    const fetch$ = this.http.get<any>(
      `${this._liveApiUrl}/account/driver-listing/`,
      { params }
    ).pipe(
      tap(data => {
        if (data && data.resultCode === '1') {
          this.activeDriversCache = data;
          console.log('✅ Drivers cache refreshed from server');
        }
      }),
      map((data: any) => {
        if (this.authService.resultCodeError(data)) {
          return throwError(() => data);
        }
        return data;
      }),
      catchError((error) => this.authService.handleError(error))
    );

    if (this.activeDriversCache) {
      console.log('🚀 Immediate emission from cache (Background refresh started)');
      // Emit cache first, then refresh from server
      return concat(of(this.activeDriversCache), fetch$);
    }

    return fetch$;
  }


  addMultipledraftOrders(payload: { orders: any[] }): Observable<any> {
    console.log('Sending Bulk Order Payload:', payload);
    return this.http.post<any>(`${this._liveApiUrl}/company/add-bulk-order/`, payload).pipe(
      map((data: any) => data),
      tap(() => console.log('API called once')),  // For debugging to see the API call count
      catchError((error) => {
        console.error('API Error:', error);
        return throwError(() => error); // Ensures error propagates and prevents retries
      })
    );
  }
  getallDraftData(): Observable<any> {
    return this.http.get<any>(`${this._liveApiUrl}/company/draft-order-listing/?page=all`).pipe(
      map((data: any) => {
        // 🔹 Check API result code for errors
        if (this.authService.resultCodeError(data)) {
          return throwError(() => data);
        }
        return data;
      }),
      catchError((error) => this.authService.handleError(error))
    );
  }
  getArchivedSheetsLogs(date?: string): Observable<any> {
    const url = date
      ? `${this._liveApiUrl}/company/get-order-dispatchsheet-logs/?date=${date}`
      : `${this._liveApiUrl}/company/get-order-dispatchsheet-logs/`;
    return this.http.get<any>(url).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }

  exportArchivedOrderSheet(sheetUrl: string): Observable<any> {
    const params = new HttpParams().set('sheet_url', sheetUrl);
    return this.http.get(`${this._liveApiUrl}/company/archived-order-sheet/export/`, { params, responseType: 'blob' }).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }
  sendMergeData(mergeData: any): Observable<any> {
    return this.http.post(`${this._liveApiUrl}/company/merge-duplicate-customer-orders/`, mergeData);
  }
  bulkorderDelete(formdata: any): Observable<any> {
    return this.http.request('DELETE', `${this._liveApiUrl}/company/delete-order/`, {
      body: formdata, // Correct way to send FormData in DELETE
    });
  }

  getAddOrderData() {
    const api1 = this.http.get(`${this._liveApiUrl}/company/company-listing/?page=1`);
    const api2 = this.http.get(`${this._liveApiUrl}/company/get-warehouse/?page=all`); // Warehouses usually stay small, keep all.
    const api3 = this.http.get(`${this._liveApiUrl}/company/address-listing/?page=1`);
    return forkJoin([api1, api2, api3]);
  }

  editOrder(id: number) {
    return this.http
      .get<any>(`${this._liveApiUrl}/company/order/${id}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }
  orderAdd(form: any) {
    return this.http.post<any>(`${this._liveApiUrl}/company/order/`, form).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.authService.handleError)
    );
  }
  orderEdit(id: Number, form: any) {
    return this.http
      .put<any>(`${this._liveApiUrl}/company/order/${id}`, form)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }
  archiveOrderList(search_text?: any, order_date?: any, order_status?: any, order_type?: any, driver_id?: any, page?: any) {
    // Clear old data first to show loader
    this._order.next(null);
    this._orderss.next(null);
    this.loadingSubject.next(true);

    let params = new URLSearchParams();

    if (search_text !== null && search_text !== undefined && search_text.trim().length > 0 && search_text !== "null") {
      params.set('search_text', search_text.trim());
    }

    if (order_date && order_date !== null && order_date !== "null" && order_date.length > 0) {
      params.set('order_date', order_date);
    }

    if (order_type && order_type !== null && order_type !== "null" && order_type.length > 0 && order_type !== 'both') {
      params.set('order_type', order_type);
    }

    if (order_status !== null && order_status !== undefined && order_status !== "undefined" && order_status !== 'null' && order_status.length > 0 && order_status[0] !== 'all') {
      params.set('order_status', order_status);
    }

    if (page !== null && page !== undefined) {
      params.set('page', (page + 1).toString());
    }

    if (driver_id && driver_id.toString().trim() !== '') {
      params.set('driver_id', driver_id);
    }

    let tail = params.toString() ? `?${params.toString()}` : '';

    this.http
      .get<any>(`${this._liveApiUrl}/company/archived-order-listing/${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((error) => {
          this.loadingSubject.next(false);
          return this.authService.handleError(error);
        })
      )
      .subscribe(
        (data: any) => {
          // Check for invalid page number FIRST - before other error checks
          if (data.errorMessage === "Invalid page number") {
            // Stop retry if we're already at page 0
            if (page <= 0) {
              this.loadingSubject.next(false);
              return;
            }
            const previousPage = page - 1;
            this.archiveOrderList(search_text, order_date, order_status, order_type, driver_id, previousPage);
            return;
          }

          // Then check for other errors

          // Success - update all data stores
          this._arkiveorder.next(data);
          this._arkiveorderss.next(data);
          this.arkiveOrderData.arkiveOrderData = data;

          // Hide loader
          this.loadingSubject.next(false);
        },
        (error) => {
          this.loadingSubject.next(false);
          this.authService.dataError(error);
        }
      );
  }
  arkiveOrderCount(order_date?: any, order_type?: any, driver_id?: any, order_status?: any, today_date?: any, search_text?: any, ispending?: any) {
    // Set loading state
    this.countLoadingSubject.next(true);

    let params = new URLSearchParams();

    if (order_date && order_date !== "null" && order_date.length > 0) {
      params.set('order_date', order_date);
    }

    if (order_type && order_type !== "null" && order_type.length > 0 && order_type !== 'both') {
      params.set('order_type', order_type);
    }

    if (driver_id && driver_id !== "null" && driver_id !== '') {
      params.set('driver_id', driver_id);
    }

    if (order_status && order_status !== "null" && order_status !== '') {
      params.set('order_status', order_status);
    }

    if (today_date && today_date !== "null" && today_date !== '') {
      params.set('today_date', today_date);
    }

    if (typeof search_text === 'string') {
      const trimmedSearch = search_text.trim();
      if (trimmedSearch && trimmedSearch !== "null") {
        params.set('search_text', trimmedSearch);
      }
    }

    if (ispending !== undefined && ispending !== null) {
      params.set('is_pending', ispending.toString());
    }

    let tail = params.toString() ? `?${params.toString()}` : '';

    this.http
      .get<any>(`${this._liveApiUrl}/company/archived-order-counts/${tail}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          this.countLoadingSubject.next(false);
          return this.authService.handleError(error);
        })
      )
      .subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            this.countLoadingSubject.next(false);
            return;
          }

          // Update count data
          this.arkiveOrderCountData.orderCount = data;
          this._arkiveorderCount.next(data);

          // Hide loader
          this.countLoadingSubject.next(false);
        },
        (error) => {
          this.countLoadingSubject.next(false);
          this.authService.dataError(error);
        }
      );
  }

  fetchCurrentPageAfterDelete(
    currentPage: number,
    pageSize: number,
    searchText?: string,
    orderDate?: string,
    orderStatus?: string,
    orderType?: string,
    driverId?: any
  ): Observable<any> {
    let params = new URLSearchParams();

    if (searchText?.trim()) params.set('search_text', searchText.trim());
    if (orderDate) params.set('order_date', orderDate);
    if (orderType && orderType !== 'both') params.set('order_type', orderType);
    if (orderStatus && orderStatus !== 'all') params.set('order_status', orderStatus);
    if (driverId) params.set('driver_id', driverId);
    if (currentPage !== null && currentPage !== undefined) params.set('page', (currentPage + 1).toString());

    const tail = params.toString() ? `?${params.toString()}` : '';

    return this.http.get<any>(`${this._liveApiUrl}/company/archived-order-listing/${tail}`)
      .pipe(
        map(data => {
          if (data.errorMessage === "Invalid page number") {
            throw new Error('Invalid page number'); // handle in component
          }
          if (this.authService.resultCodeError(data)) {
            throw new Error('Result code error');
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  sendMessage(message: string): Observable<any> {
    const formData = new FormData();
    formData.append('message', message);

    // Ensure `_liveApiUrl` is correctly defined and the endpoint is accurate
    return this.http.post<any>(`${this._liveApiUrl}/chatbot/admin-chat/`, formData);
  }
     recivingOrderDetail(id: number ,booked_in?:string) {
    return this.http
      .get<any>(`${this._liveApiUrl}/customer/customer-order/${id}?schema=${booked_in}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }

  downloadOrderExcelSheet(): Observable<Blob> {
    return this.http.get(`${this._liveApiUrl}/company/get-order-excel-sheet/`, { responseType: 'blob' }).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }

  getDispatchSheetUrl(isExport: boolean = false): Observable<any> {
    const url = isExport
      ? `${this._liveApiUrl}/company/get-order-dispatchsheet-url/?export=true`
      : `${this._liveApiUrl}/company/get-order-dispatchsheet-url/`;
    if (isExport) {
      return this.http.get(url, { responseType: 'blob' }).pipe(
        catchError((error) => this.authService.handleError(error))
      );
    }
    return this.http.get<any>(url).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }

  syncDispatchSheet(): Observable<any> {
    return this.http.get<any>(`${this._liveApiUrl}/company/sync-order-dipatchsheet/`).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }

  getDispatchSheetRows(): Observable<any> {
    const payload = {
      action: 'get'
    };
    return this.http.post<any>(`${this._liveApiUrl}/company/add-orders-to-dispatchsheet/`, payload).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }

  uploadOrderExcelSheet(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(`${this._liveApiUrl}/company/dispatch/upload/`, formData).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }

  addOrdersToDispatchSheet(orderString: string, action: string = 'add', rowUuid?: any): Observable<any> {
    const payload: any = {
      action: action,
      order_string: orderString
    };
    if (rowUuid !== undefined && rowUuid !== null && rowUuid !== '') {
      payload.row_uuid = rowUuid;
    }
    return this.http.post<any>(`${this._liveApiUrl}/company/add-orders-to-dispatchsheet/`, payload).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }

  syncDispatchSheetChanges(payload: {
    action: 'sync_changes';
    add: string[];
    edit: { row_uuid: string; order_string: string }[];
    delete: string[];
  }): Observable<any> {
    return this.http.post<any>(`${this._liveApiUrl}/company/add-orders-to-dispatchsheet/`, payload).pipe(
      catchError((error) => this.authService.handleError(error))
    );
  }
}


